var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-content', [_vm.ready ? _c('v-layout', {
    staticClass: "py-4",
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "width": "100%",
      "max-width": "1280"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs6": "",
      "md3": ""
    }
  }, [_c('dashboard-card', {
    attrs: {
      "label": "주문",
      "icon": _vm.mdiReceipt,
      "height": "150",
      "color": "teal lighten-3"
    }
  }, [_c('v-card-text', {
    staticClass: "font-size-14"
  }, [_c('v-layout', [_vm._v("총 주문건수"), _c('v-spacer'), _c('router-link', {
    attrs: {
      "to": "/console/shop/purchases/order"
    }
  }, [_c('b', {
    staticClass: "teal--text text--lighten-3"
  }, [_vm._v(_vm._s(_vm.dashboard.shop.summary.totalCount))])]), _vm._v("건")], 1), _c('v-layout', {
    staticClass: "mt-1"
  }, [_vm._v("신규주문"), _c('v-spacer'), _c('router-link', {
    attrs: {
      "to": "/console/shop/purchases/purchase?createdAt=".concat(_vm.$dayjs().format('YYYY-MM-DD'), "&createdAt=").concat(_vm.$dayjs().format('YYYY-MM-DD'))
    }
  }, [_c('b', {
    staticClass: "teal--text text--lighten-3"
  }, [_vm._v(_vm._s(_vm.dashboard.shop.summary.newOrderCount))])]), _vm._v("건")], 1), _c('v-layout', {
    staticClass: "mt-1"
  }, [_vm._v("상품준비중"), _c('v-spacer'), _c('router-link', {
    attrs: {
      "to": "/console/shop/purchases/order?status=상품준비중"
    }
  }, [_c('b', {
    staticClass: "teal--text text--lighten-3"
  }, [_vm._v(_vm._s(_vm.dashboard.shop.summary.orderConfirmationCount))])]), _vm._v("건")], 1)], 1)], 1)], 1), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs6": "",
      "md3": ""
    }
  }, [_c('dashboard-card', {
    attrs: {
      "label": "배송",
      "icon": _vm.mdiTruckFast,
      "height": "150",
      "color": "purple lighten-3"
    }
  }, [_c('v-card-text', {
    staticClass: "font-size-14"
  }, [_c('v-layout', [_vm._v("배송중"), _c('v-spacer'), _c('router-link', {
    attrs: {
      "to": "/console/shop/purchases/shipping?status=배송중"
    }
  }, [_c('b', {
    staticClass: "purple--text text--lighten-3"
  }, [_vm._v(_vm._s(_vm.dashboard.shop.summary.shippingCount))])]), _vm._v("건")], 1), _c('v-layout', {
    staticClass: "mt-1"
  }, [_vm._v("배송완료"), _c('v-spacer'), _c('router-link', {
    attrs: {
      "to": "/console/shop/purchases/shipping?status=배송완료"
    }
  }, [_c('b', {
    staticClass: "purple--text text--lighten-3"
  }, [_vm._v(_vm._s(_vm.dashboard.shop.summary.deliveredCount))])]), _vm._v("건")], 1)], 1)], 1)], 1), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs6": "",
      "md3": ""
    }
  }, [_c('dashboard-card', {
    attrs: {
      "label": "취소·교환·반품",
      "icon": _vm.mdiUndoVariant,
      "height": "150",
      "color": "blue-grey lighten-1"
    }
  }, [_c('v-card-text', {
    staticClass: "font-size-14"
  }, [_c('v-layout', [_vm._v("취소요청"), _c('v-spacer'), _c('router-link', {
    attrs: {
      "to": "/console/shop/purchases/cancel?status=취소요청"
    }
  }, [_c('b', {
    staticClass: "blue-grey--text text--lighten-1"
  }, [_vm._v(_vm._s(_vm.dashboard.shop.summary.cancelRequestCount))])]), _vm._v("건")], 1), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "mt-1"
  }, [_vm._v("교환요청"), _c('v-spacer'), _c('router-link', {
    attrs: {
      "to": "/console/shop/purchases/exchange?status=교환요청"
    }
  }, [_c('b', {
    staticClass: "blue-grey--text text--lighten-1"
  }, [_vm._v(_vm._s(_vm.dashboard.shop.summary.exchangeRequestCount))])]), _vm._v("건")], 1), _c('v-layout', {
    staticClass: "mt-1"
  }, [_vm._v("반품요청"), _c('v-spacer'), _c('router-link', {
    attrs: {
      "to": "/console/shop/purchases/return?status=반품요청"
    }
  }, [_c('b', {
    staticClass: "blue-grey--text text--lighten-1"
  }, [_vm._v(_vm._s(_vm.dashboard.shop.summary.returnRequestCount))])]), _vm._v("건")], 1)], 1)], 1)], 1), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs6": "",
      "md3": ""
    }
  }, [_c('dashboard-card', {
    attrs: {
      "label": "구매확정",
      "icon": _vm.mdiCalculatorVariant,
      "height": "150",
      "color": "light-blue lighten-2"
    }
  }, [_c('v-card-text', {
    staticClass: "font-size-14"
  }, [_c('v-layout', [_vm._v("구매확정"), _c('v-spacer'), _c('router-link', {
    attrs: {
      "to": "/console/shop/purchases/complete"
    }
  }, [_c('b', {
    staticClass: "blue--text text--lighten-2"
  }, [_vm._v(_vm._s(_vm.dashboard.shop.summary.purchasedCount))])]), _vm._v("건")], 1)], 1)], 1)], 1)], 1), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('dashboard-card', {
    attrs: {
      "label": "회원현황",
      "icon": _vm.mdiAccountSupervisorCircle,
      "color": "red"
    }
  }, [_c('v-divider'), _c('v-data-table', {
    attrs: {
      "items": _vm.members,
      "headers": _vm.membersHeaders,
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.new",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm.$dayjs(item.createdAt).format('YYYY-MM-DD') == _vm.$dayjs().format('YYYY-MM-DD') ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "amber darken-1"
          }
        }, [_vm._v(_vm._s(_vm.mdiAlphaNBox))]) : _vm._e()];
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD")))];
      }
    }], null, false, 3723353137)
  }), _c('v-divider')], 1), _c('v-layout', {
    staticClass: "mx-n1 mt-4"
  }, [_c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', [_c('v-card-actions', {
    staticClass: "font-size-14 pa-4"
  }, [_c('span', [_vm._v("오늘 가입한 회원")]), _c('v-spacer'), _c('span', [_c('router-link', {
    attrs: {
      "to": "/console/members?createdAt=".concat(_vm.$dayjs().format('YYYY-MM-DD'), "&createdAt=").concat(_vm.$dayjs().format('YYYY-MM-DD'))
    }
  }, [_c('b', {
    staticClass: "red--text"
  }, [_vm._v(_vm._s(_vm.membersSummary.todayRegisteredCount))])]), _vm._v("명")], 1)], 1)], 1)], 1), _c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', [_c('v-card-actions', {
    staticClass: "font-size-14 pa-4"
  }, [_c('span', [_vm._v("전체 회원수")]), _c('v-spacer'), _c('span', [_c('router-link', {
    attrs: {
      "to": "/console/members"
    }
  }, [_c('b', {
    staticClass: "red--text"
  }, [_vm._v(_vm._s(_vm.membersSummary.totalCount))])]), _vm._v("명")], 1)], 1)], 1)], 1)], 1), _c('v-layout', {
    staticClass: "mx-n1 mt-2"
  }, [_c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', [_c('v-card-actions', {
    staticClass: "font-size-14 pa-4"
  }, [_c('span', [_vm._v("오늘 탈퇴회원")]), _c('v-spacer'), _c('span', [_c('router-link', {
    attrs: {
      "to": "/console/member/withdrawals?withdrawnAt=".concat(_vm.$dayjs().format('YYYY-MM-DD'), "&withdrawnAt=").concat(_vm.$dayjs().format('YYYY-MM-DD'))
    }
  }, [_c('b', {
    staticClass: "red--text"
  }, [_vm._v(_vm._s(_vm.membersSummary.todaywithdrawnCount))])])], 1), _vm._v("명")], 1)], 1)], 1), _c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', [_c('v-card-actions', {
    staticClass: "font-size-14 pa-4"
  }, [_c('span', [_vm._v("총 탈퇴회원")]), _c('v-spacer'), _c('span', [_c('router-link', {
    attrs: {
      "to": "/console/member/withdrawals"
    }
  }, [_c('b', {
    staticClass: "red--text"
  }, [_vm._v(_vm._s(_vm.membersSummary.totalWithdrawnCount))])]), _vm._v("명")], 1)], 1)], 1)], 1)], 1), _c('dashboard-card', {
    staticClass: "mt-4",
    attrs: {
      "label": "월별매출통계",
      "icon": _vm.mdiChartLine,
      "color": "indigo lighten-1"
    }
  }, [_c('dashboard-chart', {
    attrs: {
      "x-axis-data": _vm.monthlyStatistics.xAxisData,
      "data": _vm.monthlyStatistics.amount
    }
  })], 1), _c('v-layout', {
    staticClass: "mt-2 mx-n2"
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('dashboard-card', {
    attrs: {
      "label": "일별결제금액",
      "icon": _vm.mdiChartBar,
      "color": "blue lighten-2"
    }
  }, [_c('dashboard-chart', {
    attrs: {
      "x-axis-data": _vm.dailyStatistics.xAxisData,
      "data": _vm.dailyStatistics.amount
    }
  })], 1)], 1), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('dashboard-card', {
    attrs: {
      "label": "일별결제건수",
      "icon": _vm.mdiChartBar,
      "color": "blue lighten-2"
    }
  }, [_c('dashboard-chart', {
    attrs: {
      "x-axis-data": _vm.dailyStatistics.xAxisData,
      "data": _vm.dailyStatistics.count
    }
  })], 1)], 1)], 1), _c('v-layout', {
    staticClass: "mt-2 mx-n2"
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('dashboard-card', {
    attrs: {
      "label": "일별결제자수",
      "icon": _vm.mdiChartBar,
      "color": "blue lighten-2"
    }
  }, [_c('dashboard-chart', {
    attrs: {
      "x-axis-data": _vm.dailyStatistics.xAxisData,
      "data": _vm.dailyStatistics.buyer
    }
  })], 1)], 1), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('dashboard-card', {
    attrs: {
      "label": "요일별 매출통계",
      "icon": _vm.mdiChartTimelineVariant,
      "color": "cyan"
    }
  }, [_c('dashboard-graph', {
    attrs: {
      "data": _vm.daysOfTheWeek
    }
  })], 1)], 1)], 1)], 1), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('dashboard-card', {
    attrs: {
      "label": "1:1 문의",
      "icon": _vm.mdiHelpCircle,
      "color": "amber"
    }
  }, [_c('v-divider'), _c('v-data-table', {
    attrs: {
      "items": _vm.questions,
      "headers": _vm.questionsHeaders,
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.subject",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('router-link', {
          attrs: {
            "to": "/console/center/questions/".concat(item._id)
          }
        }, [_vm._v(_vm._s(item.subject) + " "), _vm.$dayjs(item.createdAt).format('YYYY-MM-DD') == _vm.$dayjs().format('YYYY-MM-DD') ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "amber darken-1"
          }
        }, [_vm._v(_vm._s(_vm.mdiAlphaNBox))]) : _vm._e()], 1)];
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD")))];
      }
    }], null, false, 3878429989)
  })], 1), _c('dashboard-card', {
    staticClass: "mt-4",
    attrs: {
      "label": "공지사항",
      "icon": _vm.mdiBellRing,
      "color": "orange"
    }
  }, [_c('v-divider'), _c('v-data-table', {
    attrs: {
      "items": _vm.notifications,
      "headers": _vm.notificationsHeaders,
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.subject",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('router-link', {
          attrs: {
            "to": "/console/center/notifications/".concat(item._id)
          }
        }, [_vm._v(_vm._s(item.subject) + " "), _vm.$dayjs(item.createdAt).format('YYYY-MM-DD') == _vm.$dayjs().format('YYYY-MM-DD') ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "amber darken-1"
          }
        }, [_vm._v(_vm._s(_vm.mdiAlphaNBox))]) : _vm._e()], 1)];
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD")))];
      }
    }], null, false, 2744746886)
  })], 1), _c('dashboard-card', {
    staticClass: "mt-4",
    attrs: {
      "label": "상품문의",
      "icon": _vm.mdiHeadset,
      "color": "blue"
    }
  }, [_c('v-divider'), _c('v-data-table', {
    attrs: {
      "items": _vm.inquires,
      "headers": _vm.inquiresHeaders,
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.content",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c('router-link', {
          attrs: {
            "to": "/console/shop/inquires/".concat(item._id)
          }
        }, [_vm._v(_vm._s(item.content) + " "), _vm.$dayjs(item.createdAt).format('YYYY-MM-DD') == _vm.$dayjs().format('YYYY-MM-DD') ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "amber darken-1"
          }
        }, [_vm._v(_vm._s(_vm.mdiAlphaNBox))]) : _vm._e()], 1)];
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD")))];
      }
    }], null, false, 1059460377)
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }